import { render } from "./FavoriteList.vue?vue&type=template&id=496c949f&scoped=true"
import script from "./FavoriteList.vue?vue&type=script&lang=js"
export * from "./FavoriteList.vue?vue&type=script&lang=js"

import "./FavoriteList.vue?vue&type=style&index=0&id=496c949f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-496c949f"

export default script